import React from "react";
import "./Settings.css"
import Common_Back_Btn from "../../../common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun } from "@fortawesome/free-regular-svg-icons";
import { Form } from "react-bootstrap";
import Dark_Gray_Btn from "../../../common_components/common_btn/dark_gray_btn/Dark_Gray_Btn";
import { useNavigate } from "react-router-dom";
function Settings() {
  const Navigate = useNavigate();
  return (
    <>
      <section className="My_rewards_container Settings">
        {/* Back */}
        <Common_Back_Btn backText={"Back"} />

        {/* Reward Information */}
        <div className="My_rewards_info_box">
          {/* Recent Transactions */}
          <div className="My_rewards_recent">
            <div className="My_rewards_info_heading">
              <span className="My_rewards_recent_icon">
                <FontAwesomeIcon icon={faSun} />
              </span>
              Reward Coins Settings
            </div>
          </div>
        </div>

        <hr/>

        <div className="My_rewards_info_box">
          {/* Recent Transactions */}
          <div className="My_rewards_recent">
            <div className="My_rewards_info_heading">
              REWARD COINS SUBSCRIPTIONS
            </div>
          </div>

          <div className="subscription_field_holder">
            <div className="row">
              <div className="col-md-6">
               

                  <Form.Group className="mb-3 field_holder" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" />
                    <Form.Control placeholder="" />
                  </Form.Group>

                   <Form.Group className="mb-3 field_holder" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" />
                    <Form.Control placeholder="" />
                  </Form.Group>
              </div>
            </div>
          </div>
        </div>

        <div className="btn_holder  mt-4">
            <Dark_Gray_Btn btnText="Save"  onClick={() => Navigate("/luxury/cart")}/>
        </div>
      </section>
    </>
  );
}

export default Settings;
